export const listColumn = {
  TICKER: 'ticker',
  ISSUER: 'issuerTicker',
  TYPE: 'derivativeTypeName',
  CONVERSION_RATE: 'conversionRate',
  EXPIRE_DATE: 'maturityDate',
  REF: 'referencePrice',
  PRICE: 'matchPrice',
  VOLUME: 'totalMatchVolume',
  BEST_1_BID: 'best1Bid',
  BEST_1_ASK: 'best1Offer',
  BASIS: 'basis',
  FR_BUY_VOL: 'foreignBuyVolumeTotal',
  FR_SELL_VOL: 'foreignSellVolumeTotal',
  ISSUE_PRICE: 'issuePrice',
  CHANGE: 'priceChange',
  PERCENT_PRICE_CHANGE: 'percentPriceChange',
  VALUE: 'totalMatchValue',
  DAY_RANGE: 'dayRange',
  CEILING: 'ceilingPrice',
  FLOOR: 'floorPrice',
  OPEN: 'openPrice',
  HIGH: 'highestPrice',
  LOW: 'lowestPrice',
  PERFORMANCE: 'performance',
  FR_BUY_VAL: 'FR_BUY_VAL',
  FR_SELL_VAL: 'FR_SELL_VAL',
  PUT_THROUGH_PRICE: 'dealPrice',
  PUT_THROUGH_VOL: 'totalDealVolume',
  PUT_THROUGH_VALUE: 'totalDealValue',
  SYMBOL_TICKER: 'SYMBOL_TICKER',
  EXERCISE_PRICE: 'exercisePrice',
  AVG_PRICE_1W: 'averagePrice1Week',
  BREAK_EVEN_PRICE: 'BREAK_EVEN_PRICE',
  CURRENT_PRICE: 'orgMatchPrice',
  PREMIUM: 'PREMIUM',
  LAST_TRADING_DATE: 'lastTradingDate',
  EXECUTION_RATE_COVERED_WARRANT: 'executionRateCoveredWarrant',
  EXECUTION_RATE_SHARE: 'executionRateShare',
  COVERED_WARRANT_ORGAN_CODE: 'coveredWarrantCode',
  ORGAN_CODE: 'organCode',
  TRADING_DATE: 'tradingDate',
};

export const ignoreColumns = [
  listColumn.EXECUTION_RATE_SHARE,
  listColumn.EXECUTION_RATE_COVERED_WARRANT,
  listColumn.COVERED_WARRANT_ORGAN_CODE,
  listColumn.TRADING_DATE,
  listColumn.ORGAN_CODE,
];

export const hideColumns = [
  listColumn.EXECUTION_RATE_SHARE,
  listColumn.EXECUTION_RATE_COVERED_WARRANT,
  listColumn.COVERED_WARRANT_ORGAN_CODE,
  listColumn.ORGAN_CODE,
  listColumn.PERFORMANCE,
  listColumn.TRADING_DATE,
  listColumn.TYPE,
  listColumn.ISSUE_PRICE,
  listColumn.CHANGE,
  listColumn.PERCENT_PRICE_CHANGE,
  listColumn.VALUE,
  listColumn.CEILING,
  listColumn.FLOOR,
  listColumn.OPEN,
  listColumn.HIGH,
  listColumn.LOW,
  listColumn.PERFORMANCE,
  listColumn.FR_BUY_VAL,
  listColumn.FR_SELL_VAL,
  listColumn.PUT_THROUGH_PRICE,
  listColumn.PUT_THROUGH_VOL,
  listColumn.PUT_THROUGH_VALUE,
  listColumn.EXERCISE_PRICE,
  listColumn.BREAK_EVEN_PRICE,
  listColumn.CURRENT_PRICE,
  listColumn.LAST_TRADING_DATE,
  listColumn.EXECUTION_RATE_COVERED_WARRANT,
  listColumn.EXECUTION_RATE_SHARE,
  listColumn.COVERED_WARRANT_ORGAN_CODE,
  listColumn.ORGAN_CODE,
  listColumn.TRADING_DATE,
  listColumn.DAY_RANGE,
  listColumn.SYMBOL_TICKER,
  listColumn.AVG_PRICE_1W,
  listColumn.PREMIUM,
];
